var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.toggleOverlay}},[_c('i',{staticClass:"far fa-question"}),_vm._v(" "+_vm._s(_vm.$t('label.help'))+"\n  ")]),_vm._v(" "),(_vm.show)?_c('overlay-page',{attrs:{"file":_vm.file,"anchor":_vm.anchor,"meta":{ title: _vm.title }},on:{"close":_vm.closeOverlay}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c39d088","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/overlay/nuttrema-overlay-help-button.vue
// module id = 3031
// module chunks = 0